export * from './gutachten.component';
export * from './gutachten.component.module';